import type { Hardfork } from '../../types';

// Returns the latest hardfork whose `startTimestamp` is <= `timestamp`, i.e.
// the hardfork that is *active* at that moment. Boundary is INCLUSIVE: at
// `timestamp === item.startTimestamp` the new hardfork's blockTime applies,
// matching the on-chain semantics where the hardfork takes effect at its
// start block. Selection is independent of input ordering — the "latest"
// is decided by comparing `startTimestamp`, not by iteration order, so
// callers that construct or merge hardforks lists dynamically do not have
// to pre-sort. Returns undefined when `hardforks` is empty; when no
// hardfork has yet started at `timestamp`, falls back to `hardforks[0]`
// (the genesis entry) to preserve callers' existing behavior.
export const selectHardforkForTimestamp = ({
  hardforks,
  timestamp,
}: {
  hardforks: Hardfork[];
  timestamp: number;
}): Hardfork | undefined => {
  const first = hardforks[0];
  if (!first) return undefined;

  let selected: Hardfork | undefined;
  for (const item of hardforks) {
    if (item.startTimestamp > timestamp) continue;
    if (selected === undefined || item.startTimestamp > selected.startTimestamp) {
      selected = item;
    }
  }
  return selected ?? first;
};
